var map = {
	"./index.js": 51,
	"./module.js": 19,
	"./sp-proximity/sp-proximity.component.js": 91,
	"./sp-proximity/sp-proximity.controller.js": 52,
	"./sp-proximity/sp-proximity.scss": 93,
	"./sp-qr/qr-encode.js": 53,
	"./sp-qr/sp-qr.component.js": 95,
	"./sp-qr/sp-qr.controller.js": 54,
	"./sp-qr/sp-qr.scss": 97,
	"./web-socket.service.js": 98
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 90;


//////////////////
// WEBPACK FOOTER
// ./src/modules/reverse-ajax \.(js|css|scss)$
// module id = 90
// module chunks = 0 2 3